module.exports = __webpack_public_path__ + "img/52002747_L.7bca3da1.png";